export default function currentUserToMembership(currentUser) {
    return currentUser ? {
      // NOTE: No membership id.
      owner: currentUser,
      organization: currentUser.organization || {},
      report: true,
      manage_overview: true,
      manage_add_ons: true,
      promote: true,
      all_listings: true,
    } : {};
}
